import images from "./images";

const About = {
  sub: "About Us",
  heading: "Your Trusted Source for Quality Flooring, Tiling, and Paving",
  description: [
    "Welcome to FloorCraft, your premier destination for top-quality flooring, tiling, and paving solutions. We are committed to delivering exceptional craftsmanship and services to elevate the aesthetics, functionality, and longevity of your space. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa reprehenderit quidem.",
  ],
  experience: {
    year: 35,
    text: "years of experience",
  },
  points: [
    "Custom Flooring Solutions",
    "Expert Tiling Services",
    "High-Quality Paving Options",
    "Precision Craftsmanship",
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    alt1: "About-Image1",
    alt2: "About-Image2",
  },
  button: {
    text: "Contact Us",
    link: "Contact-us",
  },
};

export default About;